import { render, staticRenderFns } from "./IconCommoPin.vue?vue&type=template&id=705adca9"
import script from "./IconCommoPin.vue?vue&type=script&lang=js"
export * from "./IconCommoPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports